import { styled, IconButton } from '@mui/material';

import { ReactComponent as DownloadIcon } from 'assets/icons/downloadFile.svg';

export const DownloadIconW = styled(DownloadIcon)(({ theme }) => ({
  width: '32px',
  height: '32px',
  flexShrink: 0,
  cursor: 'pointer',
  backgroundColor: theme.palette.primary.main,
  borderRadius: '4px',
}));

export const DocumentW = styled('div')(({ theme }) => ({
  width: '100%',
  height: '56px',
  background: theme.palette.white.main,
  color: theme.palette.primary.main,
  border: `1px solid ${theme.palette.primary.p010}`,
  borderRadius: '8px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  columnGap: '12px',
  padding: '0 16px 0px 8px',
  overflow: 'hidden',
  transition: 'all .3s',
  '&:hover': {
    background: '#f7f7f7',
  },
}));

export const OuterW = styled('div')`
  display: flex;
  align-items: center;
  min-width: 0;
  width: 100%;
`;

export const DocumentNameW = styled('p')`
  flex: 1;
  margin: 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.primary.p080};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;

export const RemoveDocBtn = styled(IconButton)`
  width: 40px;
  height: 48px;
  border-radius: 50%;
  background: ${({ theme }) => theme.palette.white.main};
  svg {
    color: ${({ theme }) => theme.palette.info.main};
    width: 23px;
    height: 23px;
    opacity: 'unset';
  }
  &.download-button {
    svg {
      width: 35px;
      height: 35px;
    }
  }
  @media (max-width: 1023px) {
    height: unset;
    width: unset;
    background-color: ${({ theme }) => theme.palette.transparency};
    padding: 0px 8px;
    svg {
      color: ${({ theme }) => theme.palette.info.main};
      width: 16px;
      height: 16px;
    }
    &.download-button {
      svg {
        width: 30px;
        height: 24px;
      }
    }
  }
`;

export const MoreDocuments = styled('div')`
  position: absolute;
  bottom: -24px;
  right: 16px;
  color: ${({ theme }) => theme.palette.primary.main};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 16px;
  text-decoration: underline;
  cursor: pointer;
`;

export const IconBox = styled('div')`
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;

  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
  }
`;
